export default __webpack_public_path__ + "static/press-awards-buffalo-d67af16f8da108e894901de8f4d7dca7.png";